import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import PecelMadiun from './components/PecelMadiun';
import Features from './components/Features';
import Footer from './components/Footer';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-cream text-[#3E1F14]">
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <main>
        <Hero />
        <PecelMadiun />
        <Features />
      </main>
      <Footer />
    </div>
  );
}

export default App;
